import { getDynamicSemanticToken } from '../../../DesignSystem';
import { getDefaultZoomUI } from '../../../ThemeProvider';
export function getDynamicThemeToken(theme) {
    // Get dynamic semantic design token,
    // which can automatically switch between light and dark content
    const semantic = getDynamicSemanticToken(theme);
    const { typography } = theme?.zoomUI ?? getDefaultZoomUI();
    return {
        fontFamily: typography.fontFamily,
        base: {
            padding: 2,
            width: 16,
            height: 16,
        },
        label: {
            marginLeft: 6,
            color: semantic.text.stronger.neutral,
            disabled: {
                color: semantic.state.disable,
            },
        },
        endIcon: {
            marginLeft: '5px',
        },
        borderColor: {
            default: semantic.border.neutral,
            hover: semantic.border.neutral,
            active: semantic.border.neutral,
            disabled: semantic.state.disable,
        },
        background: {
            hover: semantic.state.subtle.neutral.hover,
            active: semantic.state.subtle.neutral.press,
            disabled: semantic.state.subtle.disable,
        },
        radioFocusBoxShadow: `0px 0px 0px 2px ${semantic.bg.default}, 0px 0px 0px 4px ${semantic.border.primary}`,
        selected: {
            dot: {
                background: semantic.inverse.global.default,
            },
            borderColor: {
                default: semantic.fill.global.primary,
                hover: semantic.state.primary.hover,
                active: semantic.state.primary.press,
                disabled: semantic.state.disable,
            },
        },
        description: {
            marginTop: '4px',
            color: semantic.text.neutral,
            fontSize: typography.fontSize.body,
            fontWeight: typography.fontWeight.body,
            lineHeight: typography.lineHeight.body,
        },
    };
}
